import { render, staticRenderFns } from "./commdityList1.vue?vue&type=template&id=3480165e&scoped=true&"
import script from "./commdityList1.vue?vue&type=script&lang=js&"
export * from "./commdityList1.vue?vue&type=script&lang=js&"
import style0 from "./commdityList1.vue?vue&type=style&index=0&id=3480165e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480165e",
  null
  
)

export default component.exports